import { useThemeContext } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import {
  variant1,
  variant2,
  variant3,
  variant4,
  variant5,
  SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_HONDA,
  SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_ACURA,
} from './constants';
import { getComponentFromRoute } from '../../../utils/sitecorePlaceholders';

const useConfiguration = (variant, sitecoreContext) => {
  const hasModelPageNav = getComponentFromRoute('ModelPageNav', sitecoreContext?.route);
  const header = useThemeContext('header');

  const { t } = useTranslation();

  let hasCssOverride;
  let leftColumnMobileTopPosition;
  let paddingTop = 0;
  let allItemsLabel = t('Pages.Models.Exploration.filterAllModelsLabel');

  switch (variant) {
    // HONDA_SITE_NAME
    case variant1:
      hasCssOverride = true;
      leftColumnMobileTopPosition = hasModelPageNav ? SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_HONDA : header.mobile.height;
      break;
    // ACURA_SITE_NAME
    case variant2:
      hasCssOverride = false;
      leftColumnMobileTopPosition = hasModelPageNav ? SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_ACURA : header.mobile.height;
      break;
    // ATV_PRODUCT_NAME
    case variant3:
      paddingTop = 'l';
      break;
    // PSP_SITE_NAME, MARINE_SITE_NAME,
    case variant4:
      break;
    // PE_SITE_NAME
    case variant5:
      allItemsLabel = t('Pages.Models.Exploration.filterAllProductsLabel');
      break;
    default:
      hasCssOverride = false;
      leftColumnMobileTopPosition = header.mobile.height;
      break;
  }
  return {
    paddingTop,
    hasCssOverride,
    leftColumnMobileTopPosition,
    bodyTypeTabsProps: {
      allItemsLabel,
    },
  };
};

export default useConfiguration;
